import { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form, Alert, Card, Table, ButtonGroup, Modal, ProgressBar, Badge } from "react-bootstrap";

import ToDoForm from "./ToDoForm";

import axios from "axios";
import _ from "lodash";
import Utils from "./../../common/Utils";
import ToDoSummary from "./ToDoSummary";
import moment from "moment";
import { useParams } from "react-router-dom";
import UserContext from "../../common/UserContext";
import ChoosePlans from "../../components/application/ChoosePlans";

const Todo = () => {
  const { userData } = useContext(UserContext);

  const [requireEvidence, setRequireEvidence] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingTasks, setLoadingTasks] = useState(false);
  const [naTask, setNATask] = useState(false);
  const [taskComments, setTaskComments] = useState(false);

  const { mode } = useParams();

  const initTab = () => {
    var tnames = {
      delayed: 1,
      upcoming: 2,
      complete: 3,
      upcoming30days: 4,
    };
    return _.get(tnames, mode, 0);
  };

  const [filter, setFilter] = useState({
    tab: initTab(),
    status: "",
    assignedTo: "",
    mode: 1,
  }); //1: daily, 2: weekly, 3: monthly

  const [page, setPage] = useState(1);

  const [dtCnt, setDtCnt] = useState(moment());

  const [data, setData] = useState({
    backlog: false,
    today: false,
    completed: false,
  });

  const [tasks, setTasks] = useState([]);
  const [orgMembers, setOrgMembers] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [taskMembers, setTaskMembers] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const setDate = (dir) => (e) => {
    setDtCnt(getDate(dir));
  };

  const getDate = (dir) => {
    const dt = moment(dtCnt);
    if (filter.mode === 1) {
      dt.add("day", dir);
    } else if (filter.mode === 2) {
      dt.add("day", 7 * dir);
    } else if (filter.mode === 3) {
      dt.add("month", dir);
    }

    return dt;
  };

  const getStartDate = () => {
    if (filter.mode === 1) {
      return dtCnt.format("YYYY-MM-DD");
    } else if (filter.mode === 2) {
      return moment(dtCnt).day(1).format("YYYY-MM-DD");
    } else if (filter.mode === 3) {
      return dtCnt.startOf("month").format("YYYY-MM-DD");
    }
  };

  const getDateRange = () => {
    if (filter.mode === 1) {
      return dtCnt.format("MMM DD, YYYY");
    } else if (filter.mode === 2) {
      return moment(dtCnt).day(1).format("MMM DD, YYYY") + " - " + moment(dtCnt).day(7).format("MMM DD, YYYY");
    } else if (filter.mode === 3) {
      return dtCnt.format("MMM - YYYY");
    }
  };

  const fetchTaskSummary = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("tasks/fetchtasksummary"), Utils.apiHeaders())
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setData({
            ...data,
            ..._.pick(res.data.data, ["backlog", "today", "completed", "upcoming30days"]),
          });
          Utils.addToUserData({ tasks: res.data.data.today });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const setTab = (t) => {
    setFilter({ ...filter, tab: t });
  };

  const addFilters = () => {
    let str = _.compact(_.map(filter, (fv, fk) => (fv !== "" ? `${fk}=${fv}` : undefined)));
    str.push("st=" + getStartDate());
    return "?" + str.join("&");
  };

  const fetchTasks = () => {
    setLoadingTasks(true);
    axios
      .get(Utils.apiUrl("tasks/fetchtasks") + addFilters(), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setTasks(_.get(res, "data.tasks", []));
        }
        setLoadingTasks(false);
      })
      .catch((err) => {
        setLoadingTasks(true);
        console.log(err);
      });
  };

  const deleteTask = (gTask) => {
    if (window.confirm(`You are going to delete ${gTask.name}, continue?`)) {
      setLoadingTasks(parseInt(gTask.id));
      axios
        .delete(Utils.apiUrl("tasks/deletetask/") + gTask.id, Utils.apiHeaders())
        .then((res) => {
          setLoadingTasks(false);
          if (res.data.success) {
            let tmp = [...tasks];
            _.remove(tmp, (oldtask) => parseInt(oldtask.id) === parseInt(gTask.id));
            setTasks(tmp);
          } else {
            window.alert(_.isObject(res.data.message) ? Object.values(res.data.message).join(",") : res.data.message);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const fetchTeamMembers = () => {
    axios
      .get(Utils.apiUrl("tasks/fetchteammembers"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setOrgMembers(_.get(res, "data.users", []));
          setTeamMembers(_.get(res, "data.teamMembers", []));
          setTaskMembers(_.get(res, "data.taskMembers", []));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(fetchTeamMembers, []);

  useEffect(fetchTasks, [filter, dtCnt]);

  useEffect(fetchTaskSummary, []);

  const updateTask =
    (task, doNA = false) =>
    (e) => {
      if (!doNA && task.require_evidence === "1") {
        setRequireEvidence(task);
      } else {
        setRequireEvidence(false);
        let formData = new FormData();
        formData.append("tid", task.id);
        formData.append("na", doNA ? "1" : "0");
        updateTaskSubmit(formData);
      }
    };

  const itsMe = () => {
    const udata = Utils.getUserData();
    let uid = parseInt(filter.assignedTo);
    console.log(uid, udata.uid);
    return isNaN(uid) || uid == 0 || uid == parseInt(udata.uid);
  };

  const naSubmitForm = (e) => {
    let frm = e.currentTarget;
    e.preventDefault();
    let formData = new FormData(frm);
    formData.append("tid", naTask.id);
    formData.append("na", "1");
    setNATask(false);
    updateTaskSubmit(formData);
    return false;
  };

  const updateTaskSubmit = (formData) => {
    setLoadingTasks(true);

    let headers = Utils.apiHeaders();

    headers["headers"]["Content-Type"] = "multipart/form-data";

    axios
      .post(Utils.apiUrl("tasks/updateusertask"), formData, headers)
      .then((res) => {
        setLoadingTasks(false);
        if (res.data.success) {
          setPage(1);
          setRequireEvidence(false);
          fetchTasks();
          fetchTaskSummary();
        } else {
          window.alert(res.data.message);
        }
      })
      .catch((err) => {
        setLoadingTasks(false);
        console.log(err.message);
      });
  };

  const evidenceSubmit = (e) => {
    let frm = e.currentTarget;
    e.preventDefault();

    let formData = new FormData();
    formData.append("tid", frm.tid.value);
    formData.append("na", "0");
    formData.append("evidence", frm.evidence.files[0]);

    updateTaskSubmit(formData);
  };

  const tasksForDate = (dt) => {
    let alltasks = { backlog: [], upcoming: [], completed: [] };
    let tmp = tasks.filter((t) => moment(dt).startOf("day").diff(moment(t.due_on).startOf("day")) === 0);
    if (tmp.length > 0) {
      alltasks["backlog"] = tmp.filter((t) => !t.completed === "1" && moment(t.due_on).isBefore(moment().startOf("day")));
      alltasks["upcoming"] = tmp.filter((t) => moment(t.due_on).startOf("day").diff(moment(dt).startOf("day"), "day") === 0);
      alltasks["completed"] = tmp.filter((t) => t.completed === "1");
    }
    return alltasks;
  };

  const showList = () => {
    const tabname = ["Backlog (Till Date)", "Upcoming (Today)", "Complete (This Week)", "Upcoming (30 Days)"];
    return (
      <Card border="light" className="shadow table-section mt-2 p-0">
        <Card.Header className="m-0 p-2 pt-3">
          <Card.Title>
            <Row>
              <Col>
                <b>{tabname[filter.tab - 1]}</b>
              </Col>
              <Col className="text-end">
                <Button onClick={() => setFilter({ ...filter, tab: 0 })}>X</Button>
              </Col>
            </Row>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          {loadingTasks && (
            <Alert variant="success" className="p-3">
              <p className="loading-msg">Fetching Tasks</p>
              <ProgressBar variant="success" animated now={100} />
            </Alert>
          )}

          {!loadingTasks && tasks.length === 0 && (
            <Alert variant="warning" className="mt-4 p-3">
              No task found!
            </Alert>
          )}

          {!loadingTasks && tasks.length > 0 && dailyView()}
        </Card.Body>
      </Card>
    );
  };

  const gotoDate = (wdate) => (e) => {
    setFilter({ ...filter, status: "", mode: 1 });
    setDtCnt(wdate);
  };

  const perpage = () => {
    return Utils.perpage;
  };

  const getRecordStart = () => {
    return (page - 1) * perpage();
  };

  const getPageResults = () => {
    var st = getRecordStart();
    var tmp = tasks.slice(st, st + perpage());
    return tmp;
  };

  const showTaskComments = (t) => {
    if (t.na === "1") {
      setTaskComments(t);
    } else {
      setTaskComments(false);
    }
  };

  const dailyView = () => (
    <>
      <Table bordered hover responsive className="mt-4 text-nowrap">
        <thead>
          <tr className="align-middle">
            <th style={{ width: "50px" }}>Sr. No.</th>
            <th>To Do</th>
            <th className="text-center dueon">Due At</th>
            <th className="text-center actionbtns">Update</th>
          </tr>
        </thead>
        <tbody>
          {getPageResults().map((task, idx) => {
            let completed = _.get(task, "completed", "0") === "1" || _.get(task, "completed_on", false);
            let backlog = !completed && moment().isAfter(moment(task.due_on));
            let label = completed ? "success" : backlog ? "danger" : "warning";

            return (
              <tr key={task.id} className="align-middle">
                <td>
                  <div className={`tb-lable tb-lable-${label} text-center`}>{Utils.addZero(idx + 1 + getRecordStart())}</div>
                </td>
                <td style={{ whiteSpace: "pre-wrap" }}>{task.name}<div className="text-muted">Assigned By: {task.assignerName}</div></td>
                <td className="dueon text-center">
                  <span className="text-dark">{Utils.toLocal(task.due_on).format("DD MMM YY")}</span>
                  <Badge className="d-block d-sm-inline bg-secondary text-light ms-2 p-1">{Utils.toLocal(task.due_on).format("hh:mm A")}</Badge>
                </td>
                <td className="text-center actionbtns">
                  {completed && (
                    <div className="clickable" title={task.na === "1" ? "Click to view comments" : ""} onClick={() => showTaskComments(task)}>
                      <Badge className="bg-light p-2 text-center text-dark">
                        {Utils.toLocal(task.completed_on).format("DD-MMM-YYYY hh:mm A")}
                        <Badge className={(task.na === "1" ? "bg-secondary" : "bg-success") + " ms-1"}>{task.na === "1" ? "NA" : "Complete"}</Badge>
                        {task.na !== "1" && task.require_evidence === "1" && (
                          // <a
                          //   className="btn btn-xs btn-info mx-1"
                          //   title="Uploaded Evidence File"
                          //   href={`${Utils.apiUrl("tasks/downloadevidence") + "?tid=" + task.id}`}
                          // >
                          <a
                            className="btn btn-xs btn-info mx-1"
                            title="Uploaded Evidence File"
                            target="_blank"
                            href={Utils.viewerLink(task.evidence, `tasks/downloadevidence?tid=${task.id}`)}
                          >
                            <img src={`${process.env.PUBLIC_URL}/images/download.png`} alt="Download" />
                          </a>
                        )}
                      </Badge>
                    </div>
                  )}
                  {!completed && itsMe() && (
                    <>
                      <button
                        onClick={updateTask(task, false)}
                        className={`btn btn-outline-${label} btn-md px-2 actionbtn`}
                        style={{ width: "130px" }}
                      >
                        {task.require_evidence === "1" && <img src={`${process.env.PUBLIC_URL}/images/upload.png`} alt="" />} Complete
                      </button>
                      <button
                        onClick={() => setNATask(task)}
                        className={`btn btn-outline-${label} btn-md ms-0 ms-sm-2 actionbtn`}
                        style={{ width: "80px" }}
                      >
                        NA
                      </button>
                    </>
                  )}
                  {!completed && !itsMe() && <Badge className="bg-info ms-1">Not updated</Badge>}
                  {!completed && userData.uid == task.created_by && (
                    <Button
                      variant="primary"
                      className="ms-2 clickable"
                      size="xs"
                      title="Delete this Task"
                      onClick={() => {
                        deleteTask(task);
                      }}
                    >
                      X
                    </Button>
                  )}
                </td>
                {/* <td></td> */}
              </tr>
            );
          })}
        </tbody>
      </Table>
      {tasks.length > perpage() && showPagination()}
    </>
  );

  const showPagination = () => {
    return (
      <div className="d-flex flex-row-reverse">
        {page * perpage() >= tasks.length && (
          <div className="text-disabled ms-2">
            <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
          </div>
        )}
        {page * perpage() < tasks.length && (
          <div className="clickable ms-2 text-clickable" onClick={() => setPage(page + 1)}>
            <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
          </div>
        )}
        {page > 1 && (
          <div className="clickable text-clickable" onClick={() => setPage(page - 1)}>
            Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
          </div>
        )}
        {page === 1 && (
          <div className="text-disabled">
            Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
          </div>
        )}
      </div>
    );
  };

  const weeklyView = () => {
    let curtasks = [];
    let wkdt = getStartDate();
    let wkdaydt = null;
    return (
      <Table responsive className="h-100" style={{ minHeight: "400px" }}>
        <tr>
          {_.fill(new Array(7), 0).map((v, k) => {
            wkdaydt = moment(wkdt).add(k, "day");
            curtasks = tasksForDate(wkdaydt);

            return (
              <td key={k} className="align-top h-100 d-block d-md-table-cell weeklybox">
                <div className="d-flex flex-column h-100 weekcolumn p-0 clickable" title="Click to view daily" onClick={gotoDate(wkdaydt)}>
                  <div className="weekdate">
                    {wkdaydt.format("DD")} <span className="weekday d-inline d-md-none">{wkdaydt.format("dddd")}</span>
                  </div>
                  <div className="weekday d-none d-md-block">{wkdaydt.format("dddd")}</div>
                  <Card className="m-0 p-0 flex-grow-1 h-100 border-0">
                    {["backlog", "upcoming", "completed"].map((cat) => (
                      <div className={`weekcol weekcol-${cat} my-1`}>
                        {_.slice(curtasks[cat], 0, 3).map(
                          (t, tidx) => tidx < 3 && <div className="py-1 ms-1">{_.truncate(t.name, { length: 30 })}</div>
                        )}
                      </div>
                    ))}
                  </Card>
                </div>
              </td>
            );
          })}
        </tr>
      </Table>
    );
  };

  const drawDateBox = (dt, sameMonth = true) => {
    if (_.isNull(dt)) {
      return <Card className="m-0 p-0 monthbox monthbox-empty mr-1 my-1"></Card>;
    }

    let curtasks = tasksForDate(dt);

    if (_.flatten(_.values(curtasks)).length === 0) {
      return (
        <Card className={`m-0 p-0 monthbox mr-1 my-1 bg-${sameMonth ? "white" : "grey"}`}>
          <Card.Header className={`d-block d-md-none text-${sameMonth ? "info bg-white border-info" : "secondary"}`}>
            <span className="monthdate">{moment(dt).format("DD")}</span>
            <span className="monthday">{moment(dt).format("dddd")}</span>
          </Card.Header>
          <div className="d-flex flex-column h-100">
            <div className="vh-100"></div>
            <div className="flex-growth-1 text-end pe-2 text-info d-none d-md-block">
              <b>{moment(dt).format("DD")}</b>
            </div>
          </div>
        </Card>
      );
    }

    return (
      <Card className="m-0 p-0 monthbox mr-1 my-1 clickable" title="Click to Daily View" onClick={gotoDate(moment(dt))}>
        <Card.Header className={`d-block d-md-none bg-${sameMonth ? "white" : "grey"} text-info border-info`}>
          <span className="monthdate">{moment(dt).format("DD")}</span>
          <span className="monthday">{moment(dt).format("dddd")}</span>
        </Card.Header>

        <div className="d-flex flex-column h-100">
          <div className="vh-100">
            {["backlog", "upcoming", "completed"].map((cat) => (
              <div className={`weekcol weekcol-${cat} my-1`}>
                {_.slice(curtasks[cat], 0, 1).map((t) => (
                  <div className="py-1 ms-1 d-flex flex-row">
                    <div className="text-start p-0">{_.truncate(t.name, { length: 30 })}</div>
                    {curtasks[cat].length > 1 && <div className={`month-count ${cat} ms-auto`}>+{curtasks[cat].length - 1}</div>}
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="flex-growth-1 text-end pe-2 text-info d-none d-md-block">
            <b>{moment(dt).format("DD")}</b>
          </div>
        </div>
      </Card>
    );
  };

  const monthlyView = () => {
    let mdt = getStartDate();

    return (
      <>
        <Row className="d-md-none mt-2">
          {Utils.getMonthDates(mdt).map((v1) => (
            <Col xs={6} className="p-0 px-1" key={v1}>
              {drawDateBox(v1, moment(mdt).month() === moment(v1).month())}
            </Col>
          ))}
        </Row>

        <Table responsive className="h-100 d-none d-md-table" style={{ minHeight: "300px" }}>
          <tr>
            {Utils.weekdays().map((v, k) => {
              return (
                <td key={k} className="align-top h-100" style={{ width: 100 / 7 + "%" }}>
                  <div className="d-flex flex-column h-100 p-0">
                    <div className="monthweek">{v.substring(0, 3).toUpperCase()}</div>
                    {Utils.getAllWeekDates(mdt, k + 1).map((v1) => drawDateBox(v1))}
                  </div>
                </td>
              );
            })}
          </tr>
        </Table>
      </>
    );
  };

  if (!Utils.hasAccess(4)) {
    return (
      <>
        {!userData.is_super_user && <h1 className="alert alert-danger p-5 mt-5">No access!</h1>}
        {userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>}
      </>
    );
  }

  return (
    <>
      <div className="mt-4">
        {loading && (
          <Alert variant="info" className="p-3">
            <p className="loading-msg">Fetching Task data</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>
        )}

        {!loading && (
          <>
            <ToDoSummary stats={{ ...data }} onFilter={setTab} />

            {filter.tab !== 0 && showList()}
            {filter.tab === 0 && (
              <>
                <Row className="mt-3 mt-sm-4">
                  <Col>
                    <Form>
                      <Row className="gx-1">
                        <Col className="d-none d-sm-block" sm={2}>
                          <Button variant="light" className="style1 w-100 radius-left shadow-cst filters">
                            <img src={`${process.env.PUBLIC_URL}/images/filter.png`} className="me-0 me-lg-3" alt="Filter" /> Filter
                          </Button>
                        </Col>
                        <Col className="d-none d-sm-block">
                          <select
                            className="form-control form-control-select form-select shadow-cst filters"
                            value={filter.status}
                            onChange={(e) =>
                              setFilter({
                                ...filter,
                                status: e.currentTarget.value,
                              })
                            }
                          >
                            <option value="">Status</option>
                            <option value="backlog">Backlog</option>
                            <option value="upcoming">Upcoming</option>
                            <option value="completed">Completed</option>
                          </select>
                        </Col>

                        <Col>
                          <select
                            className="form-control form-control-select form-select shadow-cst filters"
                            value={filter.assignedTo}
                            onChange={(e) =>
                              setFilter({
                                ...filter,
                                assignedTo: e.currentTarget.value,
                              })
                            }
                          >
                            <option value="0">Myself</option>
                            {taskMembers.map((tm) => (
                              <option key={tm.id} value={tm.id}>
                                {tm.title} {tm.name}
                              </option>
                            ))}
                          </select>
                        </Col>
                        <Col xs={3} lg={2}>
                          <Button
                            variant="light"
                            className="style1 w-100 radius-right shadow-cst p-0 filters"
                            onClick={(e) => setFilter({ ...filter, status: "" })}
                          >
                            Clear filter
                          </Button>
                        </Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col>
                    <Row className="d-sm-none">
                      <Col xs={4} className="m-0 p-0 ps-3">
                        <Button
                          variant={`${filter.mode === 1 ? "primary" : "light"}`}
                          className="w-100 rounded-0 roundleft"
                          onClick={(e) => {
                            setDtCnt(moment());
                            setFilter({ ...filter, mode: 1 });
                          }}
                        >
                          Daily
                        </Button>
                      </Col>
                      <Col xs={4} className="m-0 p-0">
                        <Button
                          variant={`${filter.mode === 2 ? "primary" : "light"}`}
                          className="w-100 rounded-0"
                          onClick={(e) => {
                            setFilter({ ...filter, mode: 2 });
                          }}
                        >
                          Weekly
                        </Button>
                      </Col>
                      <Col xs={4} className="m-0 p-0 pe-3">
                        <Button
                          variant={`${filter.mode === 3 ? "primary" : "light"}`}
                          className="w-100 rounded-0 roundright"
                          onClick={(e) => {
                            setFilter({ ...filter, mode: 3 });
                          }}
                        >
                          Monthly
                        </Button>
                      </Col>
                    </Row>
                    <Card border="light" className="shadow table-section p-sm-3 border-0 bottomRoundedBox mx-1 mx-sm-0">
                      <Card.Body>
                        <Row>
                          <Col className="d-flex justify-content-between">
                            <ButtonGroup aria-label="Basic example" className="shadow btn-group order-3 order-lg-1 d-none d-sm-block">
                              <Button variant="light" className="radius-left" onClick={setDate(-1)}>
                                <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
                              </Button>
                              <Button variant="primary"> {getDateRange()} </Button>
                              <Button variant="light" className="radius-right" onClick={setDate(1)}>
                                <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" />
                              </Button>
                            </ButtonGroup>
                            <Button variant="primary" className="order-2 order-lg-2 d-none d-sm-block" onClick={handleShow}>
                              Add Task
                            </Button>
                            <ButtonGroup aria-label="Basic example" className="d-none d-sm-inline shadow btn-group order-1 order-lg-3 flex-xs-fill">
                              <Button
                                variant={`${filter.mode === 1 ? "primary" : "light"}`}
                                className="radius-left"
                                onClick={(e) => {
                                  setDtCnt(moment());
                                  setFilter({ ...filter, mode: 1 });
                                }}
                              >
                                Daily
                              </Button>
                              <Button
                                variant={`${filter.mode === 2 ? "primary" : "light"}`}
                                className=""
                                onClick={(e) => {
                                  setFilter({ ...filter, mode: 2 });
                                }}
                              >
                                Weekly
                              </Button>
                              <Button
                                variant={`${filter.mode === 3 ? "primary" : "light"}`}
                                className="radius-right"
                                onClick={(e) => {
                                  setFilter({ ...filter, mode: 3 });
                                }}
                              >
                                Monthly
                              </Button>
                            </ButtonGroup>
                          </Col>
                        </Row>

                        <Row className="mt-3 d-sm-none d-block">
                          <Col className="d-flex justify-content-between">
                            <Button variant="primary" className="" onClick={handleShow}>
                              Add Task
                            </Button>
                            <ButtonGroup aria-label="Basic example" className="shadow btn-group">
                              <Button variant="light" className="radius-left" onClick={setDate(-1)}>
                                <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
                              </Button>
                              <Button variant="primary"> {getDateRange()} </Button>
                              <Button variant="light" className="radius-right" onClick={setDate(1)}>
                                <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" />
                              </Button>
                            </ButtonGroup>
                          </Col>
                        </Row>

                        {loadingTasks && (
                          <Alert variant="success" className="p-3">
                            <p className="loading-msg">Fetching Tasks</p>
                            <ProgressBar variant="success" animated now={100} />
                          </Alert>
                        )}

                        {!loadingTasks && tasks.length === 0 && (
                          <Alert variant="warning" className="mt-4 p-3">
                            No tasks found!
                          </Alert>
                        )}

                        {!loadingTasks && tasks.length > 0 && (
                          <>
                            {filter.mode === 1 && dailyView()}
                            {filter.mode === 2 && weeklyView()}
                            {filter.mode === 3 && monthlyView()}
                          </>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </div>
      {naTask !== false && (
        <Modal show size="lg" onHide={() => setNATask(false)} centered>
          <Form onSubmit={naSubmitForm}>
            <Modal.Header closeButton>
              <Modal.Title>Mark Task as NA</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-white">
              <Form.Label>Put your comments here:</Form.Label>
              <textarea className="form-control" name="comments" required={true}></textarea>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" type="submit">
                Submit NA
              </Button>
              <Button variant="secondary" onClick={() => setNATask(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
      {requireEvidence !== false && (
        <Modal show onHide={() => setRequireEvidence(false)} centered>
          <Form onSubmit={evidenceSubmit} encType="multipart/form-data">
            <input type="hidden" name="tid" value={requireEvidence.id} />
            <Modal.Header closeButton>
              <Modal.Title>Task Evidence</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-white">
              <Alert variant="info" className="p-2">
                <b>{requireEvidence.name}</b>
                <hr />
                Due by: {moment(requireEvidence.due_on).format("DD-MMM-YYYY hh:mm A")}
              </Alert>

              <Form.Label>Upload your Evidence file</Form.Label>
              <Form.Control type="file" name="evidence" required={true} />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" type="submit">
                Complete
              </Button>
              <Button variant="secondary" onClick={() => setRequireEvidence(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
      {taskComments !== false && (
        <Modal show onHide={() => setTaskComments(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Task Comments</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-white">
            <b>{taskComments.name}</b>
            <Alert variant="info" className="p-2">
              <pre style={{ fontFamily: "inherit" }}>{taskComments.comments}</pre>
            </Alert>
          </Modal.Body>
        </Modal>
      )}

      {show && (
        <ToDoForm
          show={show}
          orgMembers={orgMembers}
          onHide={handleClose}
          onAdd={() => {
            fetchTasks();
            fetchTaskSummary();
          }}
        />
      )}
    </>
  );
};

export default Todo;
